import proxyStyles from "./proxy.css?inline";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "../proxy/App.jsx";

const host = document.getElementById("widerruf-proxy-root");
const template = document.getElementById("widerruf-proxy-template");
const bootEl = document.getElementById("widerruf-proxy-boot");

if (host && template && bootEl && !host.shadowRoot) {
  const bootJson = bootEl.textContent;
  bootEl.remove();

  let boot;
  try {
    boot = JSON.parse(bootJson || "{}");

    console.log({boot});

  } catch {
    boot = { mode: "wizard" };
  }

  const shadowRoot = host.attachShadow({ mode: "open" });
  const style = document.createElement("style");
  const shell = document.createElement("div");

  style.textContent = proxyStyles;
  shell.className =
    "wp:min-h-[560px] wp:[background-color:var(--wf-bg-color,#fafaf9)] wp:px-4 wp:py-8 wp:text-[18px] wp:leading-7 wp:[color:var(--wf-text-color,#0c0a09)] wp:sm:px-6 wp:sm:py-10";
  shell.appendChild(template.content.cloneNode(true));

  shadowRoot.append(style, shell);
  template.remove();

  const mount = shell.querySelector("#widerruf-proxy-react-root");
  if (mount) {
    createRoot(mount).render(
      <StrictMode>
        <App boot={boot} designMode={host.dataset.designMode === "true"} />
      </StrictMode>,
    );
  }
}
